import { SearchIcon } from '@/components/icons'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { InputAdornment, InputBase } from '@mui/material'
import { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'

interface SearchProps {
  name: string
  onChange?: any
  value?: any
  endAdornment?: ReactNode
  className?: string
  colorHolder?: string
  colorText?: string
  endIcon?: boolean
  sx?: any
}

const SearchInput: FC<SearchProps> = ({
  name,
  value,
  onChange,
  endAdornment,
  colorText,
  colorHolder,
  className,
  endIcon = false,
  sx,
}) => {
  const themeMode = useSelector(selectTheme)

  return (
    <InputBase
      className={className}
      placeholder={name}
      value={value}
      onChange={onChange}
      sx={{
        width: '194px',
        height: '32px',
        backgroundColor: 'background.default',
        border: {
          ...(themeMode === mode_type.dark
            ? { border: '1px solid #283d43' }
            : { border: '1px solid #D7D7D7' }),
        },
        padding: '8px',
        borderRadius: '5px',
        boxShadow: '0px 0px 30px rgba(132, 132, 132, 0.25)',
        '& .MuiInputBase-input::placeholder': {
          color: colorHolder || 'text.main',
        },
        [`& .MuiInputBase-input`]: {
          fontSize: '12px',
          fontWeight: '600',
          lineHeight: '100%',
          color: colorText || 'text.main',
        },
        ...sx,
      }}
      startAdornment={
        !endIcon && (
          <InputAdornment position="start" sx={{ color: '#747474' }}>
            <SearchIcon />
          </InputAdornment>
        )
      }
      endAdornment={
        endIcon && (
          <InputAdornment position="start" sx={{ color: '#747474' }}>
            <SearchIcon />
          </InputAdornment>
        )
      }
    />
  )
}

export default SearchInput
